import React from 'react';
import { Link } from 'react-router-dom';
import "./button.css"

const Button = ({ route, text }) => {
  return (
  <Link to={ route }>
    <button className="back-button">
      { text }
    </button>
  </Link>
  )
}

export default Button